import Component from '../abstracts/Component';

export default class VerifyRegisterBySmsComponent extends Component {

  get SELECTORS() {
    return {
      dateString: '.js-expire-vcode',
      button: '.js-resend-code',
      countdown: '#vcode-countdown'
    };
  }

  constructor() {
    super();
    this.button = document.querySelector(this.SELECTORS.button);
    this.dateString = document.querySelector(this.SELECTORS.dateString);
  }


  sendClientTimeToServer() {
    $('.js-send-client-date').on('click.kr', function(e) {
      const $form = $(this).closest('form');
      const clientDate = new Date(Date.now());
      $('input#clientDate').val(clientDate);
      //$form.submit();
    });
  }

  setTimer() {

    Date.prototype.getUTCTime = function () {
      return this.getTime() - (this.getTimezoneOffset() * 60000);
    };

    const fromserver = Date.parse(this.dateString.dataset.vdate);
    const dateS = new Date(fromserver);
    const countdownDate = dateS.getUTCTime();


    return countdownDate
  }


  createTimer() {
    const countdownDate = this.setTimer();


    if(! isNaN(countdownDate)) {

      let x = setInterval(function() {
        const ttg = countdownDate - new Date().getUTCTime();
        const minutes = Math.floor((ttg % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((ttg % (1000 * 60)) / 1000);

        $('.vcode-availability-msg').removeClass('d-none');
        document.getElementById('vcode-countdown').childNodes[0].innerHTML = minutes + "m";
        document.getElementById('vcode-countdown').childNodes[1].innerHTML = seconds + "s";

        if (ttg < 0) {
          clearInterval(x);
          $('.js-resend-code').removeAttr('disabled');
          $('.js-verify-me-sms').attr('disabled', true);
          $('.vcode-availability-msg').addClass('d-none');
        }
      }, 1000);
    }
  }

  removeDisable(){
    $('#certCode').on('keyup.enableSubmit input', function(e) {
      const $form = $(this).closest('form');
      $('.js-verify-me-sms', $form).attr('disabled', false);
      if($('#certCode').val()==''){
        $('.js-verify-me-sms',$form).attr('disabled', true);
      }
    });
  }



  render() {
    const country = document.body.dataset.website;

    if(country === 'kr'){
      this.sendClientTimeToServer();

      if($('#certCode').val()==''){
        $('.js-verify-me-sms').attr('disabled', true);
      }

      this.removeDisable();
    }

    if(country === 'kr' && this.dateString) {
      this.createTimer();
    }
  }
}
